import { useEffect } from 'react';
import { useRouter } from 'next/router';
import StrapiLivePreview from '@/components/utilities/StrapiLivePreview';
import ErrorBoundary from '@/components/ErrorBoundary';
import { GoogleTagManager } from '@next/third-parties/google';

// styles
import '@/styles/globals.css';

export default function App({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    // Handle chunk load errors during Next.js route changes
    const handleRouteChangeError = (err, url) => {
      if (err.name === 'ChunkLoadError' || err.message?.includes('Loading chunk')) {
        // Navigate using window.location to force fresh chunk load
        window.location.href = url;
      }
    };

    router.events.on('routeChangeError', handleRouteChangeError);

    return () => {
      router.events.off('routeChangeError', handleRouteChangeError);
    };
  }, [router]);
  return (
    <ErrorBoundary>
      {process.env.NEXT_PUBLIC_GTM_ID && <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} />}
      <Component {...pageProps} />
      {pageProps.isPreview && <StrapiLivePreview />}
    </ErrorBoundary>
  );
}
